import roleAPI from '../../api/role'
const state = {
  roles: []
}

const actions = {

  getRoles ({commit}) {
    return roleAPI.getAll().then((response) => {
      commit('setRoles', response.data)
    }, () => {
      commit('setRoles', null)
    })
  }
}

const mutations = {
  setRoles (state, roles) {
    state.roles = roles
  }
}

const getters = {
  getRoles (state) {
    return state.roles
  },
  getRole: (state, getters) => (roleId) => {
    return state.roles.find((el) => {
      if (el.id === roleId) {
        return true
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/role.js